module.exports = __webpack_public_path__ + "static/img/img7.b4738ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img7.png
// module id = I2IU
// module chunks = 0